export default "__VITE_ASSET__gH2BUzxq__"